/**
 * Created by mykurisu on 2018/5/8.
 */
import React from 'react'
import axios from 'axios'
import Clipboard from 'clipboard'
import {connect} from 'react-redux'
import {Link} from 'react-router'
import { bindActionCreators } from 'redux'
import * as relayAction from '../../actions/relays'
import {relaycfmSetRelayRes} from '../../actions/relayConfirm'
import {Popup, Toast, Dialog, Toptips} from 'react-weui'
import {isPC, isLZWKAPP} from '../../utils'
import {WKInfiniteScroll, WKOwnDialog} from '../../components/wk'
import ResellPopup from '../resell/ResellPublishModalNew'
import '../../css/page/NewResellPage.css'
import PgyMallCard from '../../components/activity/PgyMallCard'
import { prodConfig } from '../../config'


const appInviterId = '44813679'

const renderTag = (text) => {
    return (
        <div className="right__tags-container">
            {text}
        </div>
    )
}

const renderTitle = (text, notop) => {
        return (
            <div className="resellpage__global-title" style={{marginTop: !notop ? '10px' : '0'}}>
                <p>{text}</p>
            </div>
        )

}

class ResellPage extends React.Component {

    constructor() {
        super()
        this.state = {
            selectorPopup: false,
            resellPopup: false,
            resells: [],
            has_more: false,
            next_offset: 0,
            top_resells: [],
            isPublishPending: false,
            publishData: null,
            publishDataForSelector: null,
            loadingmore: false,
            showTips: false,
            isShowIntroduction:false,
        }
        this.primaryBtnStyle = {
            type: 'primary',
            label: '确定',
        }
        this.ccancleBtnStyle = {
            type: 'default',
            label: '取消',
            onClick: () => this.props.relaySetChannelCheckRes({})
        }
        this.cancleBtnStyle = {
            type: 'default',
            label: '取消',
            onClick: () => this.props.relaySetLectureCheckRes({})
        }
    }

    componentWillMount() {
        if (!isLZWKAPP()) {
            location.replace('/')
        }
    }
    componentDidMount() {
        axios.get('/api/resell/recommend_n')
            .then(res => {
                if (res.data.code === 0) {
                    let {data} = res.data
                    this.setState({
                        resells: data.resells,
                        has_more: data.has_more,
                        next_offset: data.next_offset,
                        top_resells: data.top_resells
                    })

                    this.props.relaySetShareInfo({
                        title: data.share_info.share_title,
                        desc: data.share_info.share_description,
                        imgUrl: data.share_info.share_icon,
                        link: data.share_info.share_url
                    })
                }
            })
    }

    initCopyboard () {
        const clipboard = new Clipboard('#copy-btn')
        clipboard.on('success', (e) => {
            this.setState({
                showTips: true
            }, () => {
                setTimeout(() => {
                    this.setState({
                        showTips: false
                    })
                }, 2000)
            })
            e.clearSelection()
        })
    }

    setShareInfo (data) {
        this.props.relaySetShareInfo(data)
    }

    onClickPublish (e, type, id) {
        e.stopPropagation()
        this.setState({ isPublishPending: true })
        const inviterId = isLZWKAPP() ? appInviterId : '23526994'
        axios.get(`/api/resell/${type}/${id}/promo_info?st=lzwk_resell&inviter_id=${inviterId}&is_resell_center=True`)
            .then(res => {
                const data = res.data.data
                this.setState({
                    isPublishPending: false,
                    selectorPopup: false,
                    publishData: data,
                }, () => {
                    this.setState({
                        resellPopup: true
                    })
                    this.initCopyboard()
                })
                this.setShareInfo({
                    title: data.share_info.share_title,
                    desc: data.share_info.share_description,
                    imgUrl: data.share_info.share_icon,
                    link: data.share_info.share_url,
                })
            })
    }

    renderSelectorPopup() {
        return (
            <Popup
                show={this.state.selectorPopup}
                onRequestClose={e=>this.setState({selectorPopup: false})}
            >
                {this.state.publishDataForSelector &&
                <div className="resellpage__selector">
                    {this.state.publishDataForSelector.object.object_type === 'channel' && renderTitle('专栏转载', 'notop')}
                    {this.state.publishDataForSelector.object.object_type === 'lecture' && renderTitle('课程转载', 'notop')}
                    <div className="resellpage__selector-item">
                        <div className="list__i">
                            <div className="i__top">
                                <div className="top__img" style={{backgroundImage: `url(${this.state.publishDataForSelector.object.cover_url})`}}>

                                </div>
                                <div className="top__right">
                                    <div className="right__title">
                                        {this.state.publishDataForSelector.object.name}
                                    </div>
                                    <div className="right__tags">
                                        {this.state.publishDataForSelector.resell_info && renderTag(`分销${this.state.publishDataForSelector.resell_info.percent}%`)}
                                        {renderTag(`原价${this.state.publishDataForSelector.object.money / 100}元`)}
                                    </div>
                                    <div className="right__num">
                                        预计收益 ¥{(this.state.publishDataForSelector.object.money * this.state.publishDataForSelector.resell_info.percent / 10000).toFixed(2)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="resellpage__selector-btn">
                        <div className="resellpage__selector-btn-i" onClick={(e) => this.onClickPublish(e, this.state.publishDataForSelector.object.object_type, this.state.publishDataForSelector.object.id)}>
                            直接推广
                        </div>
                        <div className="resellpage__selector-btn-i" onClick={(e) => this.onClickRelay(this.state.publishDataForSelector.object.object_type, this.state.publishDataForSelector.object, e)}>
                            转载到我的店铺
                        </div>
                    </div>
                </div>
                }
            </Popup>
        )
    }

    renderResellPopup() {
        return (
            <Popup
                show={this.state.resellPopup}
                onRequestClose={e=>this.setState({resellPopup: false})}
            >
                {this.state.publishData &&
                <div className="resellpage__selector">
                    {renderTitle('推广赚钱')}
                    <ResellPopup
                        publishData={this.state.publishData}
                    />
                </div>
                }
            </Popup>
        )
    }

    handleLoadMore() {
        this.setState({
            loadingmore: true
        }, () => {
            axios.get('/api/resell/recommend_n',{
                params: {
                    offset: this.state.next_offset
                }
            })
                .then(res => {
                    if (res.data.code === 0) {
                        let {data} = res.data
                        let list = this.state.resells.concat(data.resells)
                        this.setState({
                            resells: list,
                            has_more: data.has_more,
                            next_offset: data.next_offset,
                            loadingmore: false
                        })
                    }
                })
        })
    }

    onClickRelay (type ,target, e) {
        e.stopPropagation()
        this.setState({
            selectorPopup: false
        }, () => {
            if (type === 'lecture') {
                this.props.relaySetCurrentLecture(target)
                this.props.newRelayPostLectureCheck(target.id)
            } else {
                this.props.relaySetCurrentChannel(target)
                this.props.newRelayPostChannelCheck(target.id)
            }
        })
    }

    onClickCreateLiveroom () {
        this.props.relaySetLectureCheckRes({})
        window.location = `/liveroom/create/guide`
    }

    onClickCreateLiveroom4C () {
        this.props.relaySetChannelCheckRes({})
        window.location = `/liveroom/create/guide`
    }

    handleSuccessRelay() {
        let list = this.state.resells.slice(0)
        let target = this.state.publishDataForSelector
        if (!target) return
        let index = list.findIndex(item => item.object.id === target.object.id)
        if (index === -1) {
            let t_list = this.state.top_resells.slice(0)
            index = t_list.findIndex(item => item.object.id === target.object.id)
            t_list[index].relay_info = {
                id: this.props.relayRes.data.lecture_id || this.props.relayRes.data.channel_id
            }
            this.setState({
                top_resells: t_list
            }, () => {
                this.props.relaycfmSetRelayRes({})
            })
            return
        }
        list[index].relay_info = {
            id: this.props.relayRes.data.lecture_id || this.props.relayRes.data.channel_id
        }
        this.setState({
            resells: list
        }, () => {
            this.props.relaycfmSetRelayRes({})
        })
    }

    handleIntroductionModal(){
        this.setState({
            selectorPopup:true,
            isShowIntroduction:true
        })
    }

    closeIntroductionModal(){
        this.setState({
            selectorPopup:false,
            isShowIntroduction:false
        })
    }


    render() {
        const { channelCheckRes: CcheckRes, lectureCheckRes: LcheckRes, account } = this.props
        let toDistribution_list = `${prodConfig.MAIN_URL}/activity/distribution_list?is_resell_center=True`;

        return (
            <div className="new__resellpage">
                <Toptips type="primary" show={this.state.showTips}>已复制到剪贴板</Toptips>
                <Toast show={this.state.isPublishPending} icon="loading"></Toast>

                {/*<div onClick={() => window.location = 'http://sina.lt/f56K'} className="resellpage__banner" style={{backgroundImage: `url(https://static-cos.lycheer.net/picture/6163375_91f15300d1e82f490c337e230a5d9b53.jpg)`}}/>*/}
                <Link to={'/specials/activity/pgy_mall?fr=student'}>
                    <img style={{marginBottom: '-10px'}} src="https://static-cos.lycheer.net/picture/7832811_9abd54a18867c6d3db55f051cbcea653.jpg"/>
                </Link>

                {this.state.isShowIntroduction && this.state.selectorPopup &&
                    (<div className="introductionModalFrame">
                        <div className="introductionModal">
                            <img src={require('../../images/resell/introduction_modal.png')} alt=""/>
                            <span className="closeIntroduction" onClick={()=>this.closeIntroductionModal()}></span>
                        </div>
                    </div>)
                }

                {this.state.top_resells && this.state.top_resells.length > 0 &&
                <div className="resellpage__slider">
                    {renderTitle('大家都在赚')}
                    <div className="main__introslider">
                        <div className="main__introslider-container" style={{height: isPC() ? '164px' : '174px'}}>
                            <div className="introslider__wrap" style={{height: isPC() ? '164px' : '174px'}}>
                                {this.state.top_resells && this.state.top_resells.map(item => (
                                    <div key={item.object.id} className="wrap__item" onClick={(e) => {
                                        if (item.relay_info) {
                                            window.location = `/${item.object.object_type}/${item.relay_info.id}`
                                        } else {
                                            if (item.object.can_relay) {
                                                this.setState({
                                                    publishDataForSelector: item
                                                }, () => {
                                                    this.setState({
                                                        selectorPopup: true
                                                    })
                                                })
                                            } else {
                                                this.onClickPublish(e, item.object.object_type, item.object.id)
                                            }
                                        }
                                    }}>
                                        <div className="item__banner" style={{backgroundImage: `url(${item.object.cover_url})`}}>

                                        </div>
                                        <div className="item__title">
                                            {item.object.name}
                                        </div>
                                        <div className="item__num">
                                            <span>
                                                <img
                                                    src="https://static-cos.lycheer.net/picture/6163375_1dabd43907669f08e614a2a02f7d9785.jpg"
                                                    alt=""/>
                                            </span>预计收益{(item.resell_info.percent * item.object.money / 10000).toFixed(2)}元
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                }

                <div className="resellpage__list">
                    <div className="resellpage__global-title">
                        <p>优质课程</p>
                        <div className="how-to-earn-Money"
                        onClick={()=>this.handleIntroductionModal()}
                        ><img src="https://static-cos.lycheer.net/picture/8173011_64e998eded921409965972bc6c0c7569.jpg" alt=""/><span>如何赚钱</span></div>
                    </div>

                    {this.state.resells && this.state.resells.map(item => {
                        return (
                            <div className="list__i" key={item.object.id}>
                                <div className="i__top" onClick={() => window.location = `/${item.object.object_type}/${item.object.id}?st=lzwk_resell&inviter_id=23526994`}>
                                    <div className="top__img" style={{backgroundImage: `url(${item.object.cover_url})`}}>

                                    </div>
                                    <div className="top__right">
                                        <div className="right__wrap">
                                            <div className="right__title">
                                                {item.object.name}
                                            </div>
                                            <div className="right__tags">
                                                {item.resell_info && renderTag(`分销${item.resell_info.percent}%`)}
                                                {renderTag(`原价${item.object.money / 100}元`)}
                                            </div>
                                        </div>
                                        <div className="right__num">
                                            预计收益{(item.resell_info.percent * item.object.money / 10000).toFixed(2)}元
                                        </div>
                                    </div>
                                </div>
                                <div className="i__bottom">
                                    {item.meta.text_url ?
                                        <div className="bottom__i-sp"
                                             onClick={() => window.location = item.meta.text_url}>
                                        <span>
                                            <img
                                                src="https://static-cos.lycheer.net/picture/6163375_8eb8ca91e301c2ecf2f202a2a70ef2bb.jpg"
                                                alt=""/>
                                        </span>查看推文
                                        </div>
                                        :
                                        <div className="bottom__i-sp" style={{opacity: 0}}>
                                        <span>
                                            <img
                                                src="https://static-cos.lycheer.net/picture/6163375_8eb8ca91e301c2ecf2f202a2a70ef2bb.jpg"
                                                alt=""/>
                                        </span>查看推文
                                        </div>
                                    }
                                    {item.relay_info ?
                                        <div className="bottom__i  bottom__i-full" onClick={() => window.location = `/${item.object.object_type}/${item.relay_info.id}?is_resell_center=True`}>
                                            直接推广
                                        </div>
                                        :
                                        <div className="i__bottom-container">
                                            <div style={{marginRight: item.object.can_relay ? '10px' : '0'}} className="bottom__i bottom__i-full" onClick={(e) => this.onClickPublish(e, item.object.object_type, item.object.id)}>
                                                直接推广
                                            </div>
                                            {item.object.can_relay &&
                                            <div className="bottom__i bottom__i-notfull" onClick={(e) => {
                                                this.setState({
                                                    publishDataForSelector: item
                                                }, () => {
                                                    this.onClickRelay(item.object.object_type, item.object, e)
                                                })
                                            }}>
                                                转到店铺
                                            </div>
                                            }
                                        </div>
                                    }
                                </div>
                            </div>
                        )
                    })}

                    <WKInfiniteScroll
                        onTouchBottom={() => this.handleLoadMore()} // 到达底部执行的方法
                        isStop={this.state.loadingmore} // 暂停执行onTouchBottom，一般是正在请求接口时触发
                        distance={300} // 距离底部多少px触发
                        isKill={!this.state.has_more} // 不再监听滚动，一般是传!has_more
                        isShowLoading={true} // 请求数据的时候（isStop）是否显示菊花
                    />
                </div>

                {this.renderSelectorPopup()}
                {this.renderResellPopup()}

                <Toast icon="loading" iconSize='small' show={this.props.lectureCheck || this.props.channelCheck}>正在检查</Toast>
                <Dialog type="ios" title='温馨提示' show={CcheckRes.code === 1 || CcheckRes.code === 2 || CcheckRes.code === 4 || CcheckRes.code === 5}
                        buttons={[{ ...this.primaryBtnStyle, onClick: () => this.props.relaySetChannelCheckRes({}) }]}>
                    {CcheckRes.msg}
                </Dialog>
                <Dialog type="ios" title='温馨提示' show={CcheckRes.code === 3}
                        buttons={[this.ccancleBtnStyle, { ...this.primaryBtnStyle, onClick: e => this.onClickCreateLiveroom4C() }]}
                >
                    {CcheckRes.msg}
                </Dialog>

                <Dialog type="ios" title='温馨提示' show={LcheckRes.code === 1 || LcheckRes.code === 2 || LcheckRes.code === 4 || LcheckRes.code === 5}
                        buttons={[{ ...this.primaryBtnStyle, onClick: () => this.props.relaySetLectureCheckRes({}) }]}>
                    {LcheckRes.msg}
                </Dialog>
                <Dialog type="ios" title='温馨提示' show={LcheckRes.code === 3}
                        buttons={[this.cancleBtnStyle, { ...this.primaryBtnStyle, onClick: e => this.onClickCreateLiveroom() }]}
                >
                    {LcheckRes.msg}
                </Dialog>

                <WKOwnDialog show={this.props.relayRes.code === 0}
                             buttons={[
                                 {
                                     label: '继续转载',
                                     type: 'default',
                                     onClick: () => {
                                         this.handleSuccessRelay()
                                     }
                                 },{
                                     label: '马上查看',
                                     onClick: () => {
                                         if (this.props.relayRes.data.lecture_id) {
                                             window.location = `/lecture/${this.props.relayRes.data.lecture_id}?is_resell_center=True&from=resell`
                                         } else if (this.props.relayRes.data.channel_id) {
                                             window.location = `/channel/${this.props.relayRes.data.channel_id}?is_resell_center=True&from=resell`
                                         } else {
                                             this.props.relaycfmSetRelayRes({})
                                         }
                                     }
                             }]}
                >
                    <div>
                        <img
                            src="https://static-cos.lycheer.net/picture/6163375_253126953d4b8324f19fbdc0d60b6444.jpg"
                            alt="" style={{width: '60px', height: '60px', margin: '0 0 17px 0'}}/>
                        <div style={{fontSize: '16px', color: '#333', lineHeight: '16px', marginBottom: '12px'}}>转载成功</div>
                        <div style={{fontSize: '14px', color: '#666'}}>该{this.props.relayRes.data && this.props.relayRes.data.lecture_id ? '课程' : '专栏'}已成功转载到你的店铺</div>
                    </div>
                </WKOwnDialog>

            </div>
        )
    }
}

export default connect(state => ({
    lectureCheck: state.relay.lectureCheck,
    lectureCheckRes: state.relay.lectureCheckRes,
    currentLecture: state.relay.currentLecture,
    lectureIsAsking: state.relay.lectureIsAsking,
    channelCheck: state.relay.channelCheck,
    channelCheckRes: state.relay.channelCheckRes,
    currentChannel: state.relay.currentChannel,
    channelIsAsking: state.relay.channelIsAsking,
    relayRes: state.relayConfirm.relayRes,
    account: state.account,
}), dispatch => bindActionCreators({ ...relayAction, relaycfmSetRelayRes }, dispatch))(ResellPage)



// WEBPACK FOOTER //
// ./src/pages/newResellPage/ResellPage.js